import React, {useEffect, useState } from "react";
import "./AboutPage.css";
import Navbar from "./Navbar";
import BreadCrumb from "./BreadCrumb";
import Footer from "./Footer";
import Download from "./Download";
import MediaCenter from "./MediaCenter";
import Newsletter from "./Newsletter";


const Partner = () => {
    const [activeSection, setActiveSection] = useState("overview");
     useEffect(() => {
        const storedSection = sessionStorage.getItem("activeSection");
        if (storedSection) {
          setActiveSection(storedSection);
          sessionStorage.removeItem("activeSection"); // Clear after applying
        }
      }, []);

    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-container">
                {/* Navigation Buttons */}

                {/* Section Content */}
                <div className="about-content">
                    <div className="about-nav">
                        <button
                            className={activeSection === "overview" ? "active" : ""}
                            onClick={() => setActiveSection("overview")}
                        >
                            Overview
                        </button>
                        <button
                            className={activeSection === "whychoose" ? "active" : ""}
                            onClick={() => setActiveSection("whychoose")}
                        >
                            Why Choose RiseFX As Your Broker
                        </button>
                        <button
                            className={activeSection === "benefit" ? "active" : ""}
                            onClick={() => setActiveSection("benefit")}
                        >
                            Benefits of Joining Our Partner Program
                        </button>

                    </div>
                    {activeSection === "overview" && (
                        <section className="about-section risefx-benefits-section">
                        <div className="risefx-container">
                            <h1 className="risefx-title">
                                Partner with RiseFX Forex Broker as an Introducing Broker (IB)
                            </h1>
                            <p className="risefx-description">
                            Are you interested in expanding your business, earning more income, and establishing a strong footing in the financial markets? Join forces with RiseFX, an internationally reputed online brokerage firm, and become an Introducing Broker (IB) by referring new traders to our trading platform. You have the flexibility to utilize your network and skills and earn decent commissions for each trader you refer to RiseFX.
                            </p>
                            <p className="risefx-description">
                            As a high-end trading platform, RiseFX offers an easy and professional trading experience with advanced charting features, real-time market analysis, and multi-asset trading functionality. Our platform is specifically created to meet the needs of both new and experienced traders with a smooth and efficient trading process. With RiseFX, you benefit from best-in-class technology, committed support, and marketing resources to facilitate your growth and increase your revenues.
                            </p>
                            <p className="risefx-description">
                            It is easy and profitable to join as an Introducing Broker. You get paid commissions for each referral while your clients enjoy a safe, feature-rich, and internationally acclaimed trading platform. You're an independent financial advisor, a trading specialist, or you have a large network of contacts in the investment community. This is your opportunity to create a long-term income stream. Join RiseFX today and become a step ahead in your financial success!

                            </p>
                        </div>
                    </section>                
                    )}


                    {activeSection === "whychoose" && (
                       <section className="about-section risefx-benefits-section">
                       <div className="risefx-container">
                           <h1 className="risefx-title">Why Choose RiseFx? A Trusted Brand in Global Trading</h1>
                   
                           <h2 className="risefx-subtitle">Reputation</h2>
                           <p className="risefx-description">
                               RiseFX has built a strong position in the forex industry by giving 24/5 services and transparent 
                               trading conditions. Our commitment to integrity and ethical business practices sets us apart as a 
                               broker of choice for traders and partners alike. Our main priority is client’s satisfaction. Our 
                               experienced team is available 24/5 to guide traders with any inquiries, ensuring a smooth and 
                               hassle-free trading experience. RiseFX offers comprehensive educational resources, including webinars, 
                               market analysis, trading signals, and expert insights to help traders make informed decisions.
                           </p>
                   
                           <h2 className="risefx-subtitle">Advanced Technology</h2>
                           <p className="risefx-description">
                               At RiseFX, clients get powerful trading platforms with advanced tools to stay ahead in the trading 
                               market through our cutting-edge technology. Traders can trade multiple markets with one account like 
                               forex, commodities, currency, and indices. Our lightning-fast trade execution ensures trades are executed 
                               within milliseconds. The machine learning algorithms provide real-time market insights and predictive 
                               analytics. With our fast execution, advanced tools, and secure trading environment, RiseFX gives you 
                               everything you need to succeed in trading.
                           </p>
                   
                           <h2 className="risefx-subtitle">Competitive Conditions</h2>
                           <p className="risefx-description">
                               At RiseFX, we know that every trader wants the best trading environment. Therefore, we provide competitive 
                               conditions designed for experienced traders, including low costs, fast execution, and flexible trading options. 
                               Our competitive trading conditions attract and maintain clients. You can keep more of your earnings with our 
                               low commission structure. For most trades, you’ll pay minimal or even zero commission. Better trading conditions 
                               mean lower costs, faster execution, and more opportunities to succeed. With tight spreads, low commissions, and 
                               high leverage, you get the best value for your trades.
                           </p>
                       </div>
                   
                       <div className="risefx-mobile">
                           <div className='popup-content'>
                               <img src='/images/QRcode1.png' alt='QR Code 1' className='qr-img' />
                               <a href='https://panel.therisefx.com/platform/TheRiseFX-1.0.apk'>
                                   <img src='images/android-download.png' className='download-icon' alt='Download for Android' />
                               </a>
                           </div>
                           <div className='popup-content'>
                               <img src='/images/QRcode2.png' alt='QR Code 2' className='qr-img' />
                               <a href='https://apps.apple.com/us/app/mobiustrader-7/id1355359598'>
                                   <img src='images/ios-download.png' className='download-icon' alt='Download for iOS' />
                               </a>
                           </div>
                       </div>
                   </section>
                   
                    

                    )}


                    {activeSection === "benefit" && (
                        <section className="about-section risefx-benefits-section">
                        <div className="risefx-container">
                            <h1 className="risefx-title">Lucrative Commission Structure</h1>
                            <p className="risefx-description">
                            Maximize your earnings with our highly rewarding commission structure. At RiseFX, we value our partners and offer one of the most competitive commission plans in the industry. Whether you’re an Introducing Broker (IB) or a money manager, our payout system ensures you receive the best possible returns for your efforts. There are no limits to your earning potential—the more you grow, the more you earn. We also guarantee fast and secure commission processing, so you get paid on time, every time.
                            </p>
                    
                            <h2 className="risefx-title">Dedicated Support</h2>
                            <p className="risefx-description">
                            At RiseFX, we are committed to providing exceptional support to our partners. We offer 24/5 customer service, ensuring you always have assistance when needed. Our expert team is available Monday to Friday, ready to help you with trading guidance, technical support, or account-related inquiries. Whether you are a beginner or a professional trader, you can reach us via live chat, email, or phone for prompt and reliable assistance. When you partner with RiseFX, you’re never alone—we’re always here to help you succeed.
                            </p>
                    
                            <h2 className="risefx-title">Exclusive Access to Resources</h2>
                            <p className="risefx-description">
                            Unlock your full trading potential with comprehensive educational and analytical tools. At RiseFX, we believe that informed traders make better decisions, which is why we provide access to valuable market insights, expert analysis, and real-time updates. Stay ahead of the competition with daily market reports, economic news, and trading signals that help refine your strategy. Our advanced resources equip you with everything you need to trade confidently and efficiently.
                            </p>
                    
                            <h2 className="risefx-title">Join Our Partner Program Today!</h2>
                            <p className="risefx-description">
                            Becoming an Introducing Broker (IB) with RiseFX is a great opportunity to expand your business, increase your earnings, and work with a globally trusted broker. Whether you are an experienced trader or just starting, our IB program is structured to help you grow. Benefit from high commissions, powerful marketing tools, and a trusted reputation in the Forex industry. We provide full support to help you attract and retain clients effortlessly. Join the RiseFX IB Program today and build a successful and rewarding partnership!
                            </p>
                        </div>
                    </section>
                    



                    )}
                </div>
            </div>
            <MediaCenter />
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
};

export default Partner;
